module.exports = __webpack_public_path__ + "static/Michael_Brudno_headshot_lores-741548d8c906ee783e00895306f8de1f.png";